"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _TMRDWUTBcjs = require('../__chunks/TMRDWUTB.cjs');


var _7DAL4U2Wcjs = require('../__chunks/7DAL4U2W.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/toolbar/toolbar-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function ToolbarProvider(props = {}) {
  const store = _TMRDWUTBcjs.useToolbarStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _7DAL4U2Wcjs.ToolbarContextProvider, { value: store, children: props.children });
}


exports.ToolbarProvider = ToolbarProvider;
